// TODO remove undefined once types are updated
export const buildAddressLabel = (values: (string | undefined)[]) => {
  const addressString = values
    .map((l) => l && l.trim())
    .filter((l) => l)
    .join(', ');

  return addressString;
};
